import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSmilePlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.8346 6.41693V7.00027C12.8287 8.17762 12.4666 9.32563 11.7961 10.2934C11.1255 11.2611 10.1778 12.0033 9.07753 12.4224C7.97726 12.8414 6.77593 12.9177 5.63149 12.6413C4.48704 12.3648 3.45304 11.7485 2.66542 10.8733C1.87781 9.9982 1.37344 8.90521 1.21862 7.73807C1.06381 6.57092 1.2658 5.38425 1.79803 4.33405C2.33027 3.28384 3.16784 2.41928 4.20063 1.854C5.23343 1.28873 6.4131 1.04921 7.58457 1.16693M4.66797 8.16689C4.66797 8.16689 5.54297 9.33356 7.0013 9.33356C8.45964 9.33356 9.33464 8.16689 9.33464 8.16689M5.2513 5.25022H5.25714M8.7513 5.25022H8.75714M9.33464 2.91689H12.8346M11.0846 1.16689V4.66689",
		stroke: "#8B909C",
		strokeWidth: 1.16667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSmilePlus;
